import { defineComponent as _defineComponent } from 'vue'

import { computed, defineComponent, onMounted, watchEffect } from 'vue'
import { useRoute } from 'vue-router/composables'

import SignInForm from '@/components/onboarding/signIn/SignInForm.vue'
import OnboardingScreen from '@/components/onboarding/OnboardingScreen.vue'
import { useOnboardingStore } from '@/stores/onboarding'
import { logEvent } from '@/utils/utility-manager'

const __default__ = defineComponent({
  components: {
    SignInForm,
    OnboardingScreen,
  },
  layout: 'centered',
  head() {
    return {
      title: this.$t('lambusAllInOneApp') as string,
    }
  },
})

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  __name: 'sign-in',
  setup(__props) {

const onboardingStore = useOnboardingStore()
const route = useRoute()

onboardingStore.previousAuthenticatingRoutePath = '/sign-in'

onMounted(() => {
  logEvent('sign_in_page_viewed')
})

const hasActiveOnboardingAction = computed(() => {
  return (
    typeof route.query.newTrip === 'string' ||
    typeof route.query.inspirationId === 'string' ||
    typeof route.query.pinCode === 'string' ||
    typeof route.query.assistant_sid === 'string' ||
    route.query.utm_source === 'onboarding'
  )
})

watchEffect(() => {
  if (typeof route.query.assistant_sid === 'string') {
    onboardingStore.activateAssistantSession(route.query.assistant_sid)
  } else {
    onboardingStore.activeAssistantSessionHandle = null
    onboardingStore.activeAssistantSession = null
  }
})

return { __sfc: true,onboardingStore, route, hasActiveOnboardingAction, SignInForm, OnboardingScreen }
}

})